import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CampaignTemplate } from 'components/Templates'

const Campaign: FC = () => {
  return (
    <Layout headline={'キャンペーン'} iconPath={'/icon/white/cms.svg'} title={'キャンペーン'}>
      <CampaignTemplate />
    </Layout>
  )
}

export default Campaign
